import { render, staticRenderFns } from "./VolumeUpsellProposalBox.vue?vue&type=template&id=560c2888&"
import script from "./VolumeUpsellProposalBox.vue?vue&type=script&lang=ts&"
export * from "./VolumeUpsellProposalBox.vue?vue&type=script&lang=ts&"
import style0 from "./VolumeUpsellProposalBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560c2888')) {
      api.createRecord('560c2888', component.options)
    } else {
      api.reload('560c2888', component.options)
    }
    module.hot.accept("./VolumeUpsellProposalBox.vue?vue&type=template&id=560c2888&", function () {
      api.rerender('560c2888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VolumeUpsellProposalBox.vue"
export default component.exports